import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'global',
    conver: 'en-US',
    alia: 'en',
    region: 'United States',
    regionText: 'United States',
    language: 'English',
    languageText: 'English',
    appId: 27,
    acceptLanguage: 'en-US,en;q=0.9',
};
export default theLocale;
